(() => {
  if (customElements.get('balu-product-shipping')) return;

  const cartShippingTotal = (cart) => {
    const itemsTotal = (cart?.items || [])
      .filter((item) => item.requires_shipping)
      .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
    const discounts = (cart?.cart_level_discount_applications || [])
      .reduce((sum, discount) => sum + Number(
        discount.total_allocated_amount || discount.discount_application?.total_allocated_amount || 0
      ), 0);

    return Math.max(0, itemsTotal - discounts);
  };

  class BaluProductShipping extends HTMLElement {
    connectedCallback() {
      this.onCartChange = (event) => {
        this.dataset.cartTotal = String(cartShippingTotal(event.detail?.cart));
        this.render();
      };
      this.onVariantChange = (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;

        this.dataset.variantPrice = String(variant.price || 0);
        this.dataset.requiresShipping = String(variant.requires_shipping !== false);
        this.render();
      };

      document.addEventListener('cart:change', this.onCartChange);
      document.addEventListener('variant:change', this.onVariantChange);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChange);
      document.removeEventListener('variant:change', this.onVariantChange);
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || Shopify?.currency?.active || 'CHF';
      const amount = Math.max(0, cents) / 100;

      if (currency === 'CHF') {
        const formatted = new Intl.NumberFormat('de-CH', {
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          maximumFractionDigits: 2
        }).format(amount);
        return `CHF ${formatted}${Number.isInteger(amount) ? '.–' : ''}`;
      }

      return new Intl.NumberFormat(Shopify?.locale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format(amount);
    }

    render() {
      const target = this.querySelector('[data-balu-product-shipping-message]');
      if (!target) return;

      if (this.dataset.requiresShipping === 'false') {
        this.hidden = true;
        return;
      }

      const threshold = Number(this.dataset.threshold || 12000);
      const cartTotal = Number(this.dataset.cartTotal || 0);
      const variantPrice = Number(this.dataset.variantPrice || 0);
      const projectedTotal = cartTotal + variantPrice;

      this.hidden = false;
      this.classList.toggle('is-reached', cartTotal >= threshold || projectedTotal >= threshold);

      if (cartTotal >= threshold) {
        target.textContent = this.dataset.cartMessage || '';
      } else if (projectedTotal >= threshold) {
        target.textContent = this.dataset.itemMessage || '';
      } else {
        target.textContent = (this.dataset.missingMessage || '')
          .replace('[[amount]]', this.formatMoney(threshold - projectedTotal));
      }
    }
  }

  customElements.define('balu-product-shipping', BaluProductShipping);
})();
